module.exports = __webpack_public_path__ + "images/cc.21b2aa13eb0b71ba633f.png";